//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from "../../blue-search/transitions/Expand.vue";
import Group from "./Group.vue";

export default {
	props: ['filters', 'executeSearch', 'setFilterValue'],
	data() {
		return {
			mobileDrawerOpen: false
		}
	},
	components: {
		TransitionExpand,
		Group
	},
	methods: {
		setVal (filter, val) {
			let value;
			if (typeof val === "object") value = val.target.value;
			else value = val;
			this.setFilterValue(filter, value);
		},
		toggleMobileDrawer(toggle = !this.mobileDrawerOpen){
			this.mobileDrawerOpen = toggle;
		}
	}
}
